import React from 'react'
import { Link } from 'react-router-dom';

export const Popular_blogs = () => {
  return (
    <div className='popular_blog_list sticky top-[130px] self-start border border-gray-300 shadow-sm rounded-md bg-white'>
      <h4 className="!bg-gray-100 !py-3 !px-4 !m-0 !mb-3 !border-b !border-gray-300 !text-gray-800 font-semibold text-center">POPULAR BLOGS</h4>
      <ol className="p-2 m-0 ps-4 pe-2">
        <li><Link to=''>Quae cumque et sed sit aut aspernatur.</Link></li>
        <li><Link to=''>This is for new post updated</Link></li>
        <li><Link to=''>Voluptas delectus qui sunt unde debitis.</Link></li>
        <li><Link to=''>Cum enim aut ut nostrum consequuntur sit voluptas quam.</Link></li>
        <li><Link to=''>Minus soluta qui dicta natus nulla.</Link></li>
      </ol>
    </div>
  )
}

export default Popular_blogs;


